import { GalleryLayout5Theme } from '@components/gallery/components/gallery-layout-5/enum';
import { GalleryLayout5Style } from '@components/gallery/components/gallery-layout-5/model';

export const galleryLayout5Style: { [key: string]: GalleryLayout5Style } = {
  [GalleryLayout5Theme.WHITE]: {
    backgroundColor: 'WHITE',
    cta: {
      size: 'NORMAL',
      icon: {
        name: 'CHEVRON_RIGHT',
        position: 'RIGHT',
        color: 'BLACK',
      },
      theme: 'WHITE',
    },
  },
  [GalleryLayout5Theme.CREAM]: {
    backgroundColor: 'CREAM',
    cta: {
      size: 'NORMAL',
      icon: {
        name: 'CHEVRON_RIGHT',
        position: 'RIGHT',
        color: 'BLACK',
      },
      theme: 'TRANSPARENT_BLACK',
    },
  },
};
